import type { Dispatch, KeyboardEvent, SetStateAction } from "react";
import type { CommandItem } from "./commandItem";
import { lastIndex, wrapIndex } from "./paletteModel";

interface PaletteKeyboardContext {
  results: CommandItem[];
  active: number;
  setActive: Dispatch<SetStateAction<number>>;
  run: (item: CommandItem | undefined) => void;
  onClose: () => void;
}

/**
 * Keydown handler for the palette dialog: ↑ ↓ move (wrapping), Home End jump, Enter runs the
 * highlighted result, Escape closes, and Tab is held so the focus stays in the search field.
 */
export function paletteKeyDownHandler({ results, active, setActive, run, onClose }: PaletteKeyboardContext): (e: KeyboardEvent<HTMLDivElement>) => void {
  return (e) => {
    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setActive((i) => wrapIndex(i, 1, results.length));
        return;
      case "ArrowUp":
        e.preventDefault();
        setActive((i) => wrapIndex(i, -1, results.length));
        return;
      case "Home":
        e.preventDefault();
        setActive(0);
        return;
      case "End":
        e.preventDefault();
        setActive(lastIndex(results.length));
        return;
      case "Enter":
        e.preventDefault();
        run(results[active]);
        return;
      case "Escape":
        e.preventDefault();
        e.stopPropagation();
        onClose();
        return;
      case "Tab":
        e.preventDefault();
    }
  };
}
